import type { ComponentPropsWithoutRef } from 'react'

import type { Lead } from '../../../api/leads.api.ts'

interface OwnProps {
  option: Lead
}

type Props = OwnProps & ComponentPropsWithoutRef<'li'>

export const Option = ({ option, ...props }: Props) => {
  return (
    <li {...props}>
      <div style={{ width: '100%' }}>
        <div>{`${option.full_name} (${option.phone || 'no phone'})`}</div>
        <div style={{ fontSize: '0.875rem', color: '#666' }}>{option.email}</div>
      </div>
    </li>
  )
}

export default Option
